import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ChangeShopSettings } from "@shared/interfaces";
import { BehaviorSubject, Subject } from "rxjs";
import { environment } from "src/environments/environment";


@Injectable()
export class AdminSettingsShopsService {

  private settings_shops$ = new BehaviorSubject<any[]>([]);
  private search_shops$ = new Subject<string>();

  constructor(private http: HttpClient) {}

  listenShopSearch() {
    return this.search_shops$.asObservable();
  }

  setShopSearch(search: string) {
    this.search_shops$.next(search);
  }

  setSettingsShops(shops: any[]) {
    this.settings_shops$.next(shops);
  }

  getSettingsShops() {
    return this.settings_shops$.asObservable();
  }

  createShop(name: string = '', active: boolean, partneris:any, description: string = '') {
    let url = environment.apiUrl + '/operator/shops';
    return this.http.post(url, {
      name,
      active,
      partneris,
      description,
    });
  }

  deleteShop(shop_id: number) {
    let url = environment.apiUrl + `/operator/shops/${shop_id}`;
    return this.http.delete(url);
  }

  hideShop(shop_id: number) {
    let url = environment.apiUrl + `/operator/hideShop/${shop_id}`;
    return this.http.post(url, {});
  }

  editShop(shop_id: number, body: ChangeShopSettings) {
    let url = environment.apiUrl + `/operator/shops/${shop_id}`;
    return this.http.post(url, body);
  }

}